/* src/app/components/Select/styles.js */

export default theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/Select/styles.js